export default __webpack_public_path__ + "static/media/wardrobe1.83debde4.jpg";